<template>
  <span class="member-avatar" :style="{ background: member ? member.color : '#ccc', width: size + 'px', height: size + 'px', fontSize: (size * 0.42) + 'px' }">
    <template v-if="member">{{ member.name.slice(0, 1) }}</template>
    <template v-else>?</template>
  </span>
</template>

<script>
export default {
  name: 'MemberAvatar',
  props: {
    member: { type: Object, default: null },
    size: { type: Number, default: 26 }
  }
}
</script>

<style scoped>
.member-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #fff;
  font-weight: 700;
  flex-shrink: 0;
}
</style>
